/* eslint-disable jsx-a11y/no-noninteractive-tabindex -- WCAG 2.1.1 requires the overflow region itself to receive keyboard focus. */
import type { JsonScalar } from "../contracts/types";
import type { DiffResult } from "../domain/diff";

interface DiffPreviewProps {
  diff: DiffResult;
  fieldOrder: string[];
}

function formatCell(value: JsonScalar): string {
  if (value === null || value === undefined) return "∅";
  return String(value);
}

export function DiffPreview({ diff, fieldOrder }: DiffPreviewProps) {
  if (diff.rows.length === 0) {
    return (
      <p className="empty-state">
        Aún no hay resultado. Ejecuta el fixture para ver cada decisión.
      </p>
    );
  }

  return (
    <div>
      <p className="field-hint">
        Vista previa de {diff.summary.previewRows} de {diff.summary.totalRows} fila(s) ·{" "}
        {diff.summary.changedCells} de {diff.summary.totalCells} celdas cambiaron · campos
        afectados: {diff.summary.changedFields.join(", ") || "ninguno"}.
      </p>
      <div
        aria-label="Vista previa desplazable del dataset"
        role="region"
        style={{ overflowX: "auto" }}
        tabIndex={0}
      >
        <table className="coverage-table">
          <caption>
            Vista previa: valor original frente a valor enmascarado, por fila y campo
          </caption>
          <thead>
            <tr>
              <th scope="col">Fila</th>
              {fieldOrder.map((field) => (
                <th scope="col" key={field}>
                  {field}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {diff.rows.map((row) => (
              <tr key={row.index}>
                <th scope="row">{row.index + 1}</th>
                {row.cells.map((cell) => (
                  <td key={cell.field} className={cell.changed ? "severity-warning" : undefined}>
                    {cell.changed ? (
                      <>
                        <span style={{ textDecoration: "line-through" }}>
                          {formatCell(cell.before)}
                        </span>
                        <br />
                        <span>{formatCell(cell.after)}</span>
                      </>
                    ) : (
                      formatCell(cell.after)
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
